module.exports = __webpack_public_path__ + "img/7_103.5b6c41fa.png";